import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor() { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Check if the request is for our API
        if (request.url.startsWith(environment.apiUrl)) {
            // Clone the request and add withCredentials: true
            request = request.clone({
                withCredentials: true
            });
        }
        return next.handle(request);
    }
}
